import React from 'react';
import localization from '../helpers/localization.js';
import SaunaImageContainer from '../containers/SaunaImageContainer';
import InputWithLabel from './InputWithLabel';
import validator from '../helpers/measurementValidator'
import { Form, Field } from 'react-final-form';

const SaunaMeasurementsPage = ({ prevPage, skipMeasurements, allowSkipMeasurements, onMeasurementsSubmit }) => {
    let skipButton = skipMeasurementsButton(allowSkipMeasurements, skipMeasurements);
    let measurementValidator = new validator();
    return (<div className="page">
        <SaunaImageContainer />
        <h1>{localization.giveSaunaMeasurements}</h1>
        <h2>{localization.writeDownSaunanMeasurements}</h2>
        <Form model="measurements" validate={values => { return measurementValidator.validate(values); }} id="measurementForm" hideNativeErrors={false} onSubmit={onMeasurementsSubmit} render={({ handleSubmit, form, submitting, pristine, values }) => (
            <form onSubmit={handleSubmit}>
                <InputWithLabel label={localization.doorWallWidth} name="doorWallWidth" placeHolder={localization.doorWallWidth + " mm."} type="number" />
                <InputWithLabel label={localization.depth} name="depth" type="number" placeHolder={localization.saunaDepth + " mm."} />
                <InputWithLabel label={localization.height} name="height" type="number" placeHolder={localization.saunaHeight + " mm."} />
                <InputWithLabel label={localization.doorWidth} name="doorWidth" type="number" placeHolder={localization.saunaDoorWidth + " mm."} />
                <div className="inputWithLabel">
                    <label htmlFor="comment" className="textinputLabel">{localization.commentMeasurements}</label>
                    <Field name="comment" component="textarea" />
                </div>
                {skipButton}
                <InputWithLabel label={localization.floorImage} name="floorImage" type="file" multiple />
                <div className="changePhaseRow">
                    <span className="orangeButton changePhaseButton" onClick={() => { prevPage() }}> <span className="buttonTxt">&#8592;  {localization.prevPhase}</span></span>
                    <button className="orangeButton changePhaseButton" type="submit"> <span className="buttonTxt"> {localization.nextPhase} &#8594;</span></button>
                </div>
            </form>)}>
        </Form>
    </div>)

};
export default SaunaMeasurementsPage

let skipMeasurementsButton = (render, onClick) => {
    if (render) {
        return <div className="roundedButton" onClick={() => { onClick(); }}>{localization.noMeasurements}</div>
    }
    else {
        return "";
    }

}

